/* eslint-disable react-hooks/exhaustive-deps */
import { AspectRatio, Box, Center, Container, Flex, SimpleGrid, Text, Tooltip } from '@chakra-ui/react';
import { faChartLine, faDollarSign, faHandHoldingUsd, faSearchDollar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import Card from '../../components/Card/Card';
import PrintLayout from '../../components/Print/PrintLayout';
import c from '../../constant';
import './style.css';

const groups = ['monthly', 'quarterly', 'semesterly', 'annually'];

function InsuranceMarketDataMenu() {
	const history = useHistory();
	const { t } = useTranslation();
	const menuList = useMemo(() => {
		return [
			{
				name: 'insuranceMarketData',
				icon: faChartLine,
				path: '/insurance-market-data/industry-monthly-summarized-report',
				roles: ['admin', 'marketData'],
				badge: null,
				group: 'monthly',
			},
			{
				name: 'Financial Statements for Insurance Company',
				icon: faDollarSign,
				path:
					'/insurance-market-data/industry-quarterly-summarized-fs-report?period=quarterly&reportId=' +
					c.quarterly_financial_statements +
					'&report=ews',
				roles: ['admin', 'marketData'],
				badge: null,
				group: 'quarterly',
			},
			{
				name: 'Report on Investment for Insurance Company',
				icon: faHandHoldingUsd,
				path:
					'/insurance-market-data/industry-quarterly-summarized-ir-report?period=quarterly&reportId=' +
					c.quarterly_report_on_investment +
					'&report=ir',
				roles: ['admin', 'marketData'],
				badge: null,
				group: 'quarterly',
			},
			{
				name: 'Audited Financial Statement for Insurance Company',
				icon: faSearchDollar,
				path:
					'/insurance-market-data/industry-annually-summarized-fs-report?period=annually&reportId=' +
					c.annually_audited_financial_statements +
					'&report=ews',
				roles: ['admin', 'marketData'],
				badge: null,
				group: 'annually',
			},
			{
				name: 'Unaudited Financial Statement for Insurance Company',
				icon: faDollarSign,
				path:
					'/insurance-market-data/industry-annually-summarized-fs-report?period=annually&reportId=' +
					c.annually_unaudited_financial_statements +
					'&report=ews',
				roles: ['admin', 'marketData'],
				badge: null,
				group: 'annually',
			},
			{
				name: 'Report on Investment for Insurance Company',
				icon: faHandHoldingUsd,
				path:
					'/insurance-market-data/industry-annually-summarized-ir-report?period=annually&reportId=' + c.annually_report_on_investment + '&report=ir',
				roles: ['admin', 'marketData'],
				badge: null,
				group: 'annually',
			},
		];
	}, []);

	const menuData = useMemo(() => {
		let groupMenu = [];
		menuList.map((m) => groupMenu.push(m.group));
		groupMenu = _.uniq(groupMenu);
		const groupMenuOrder = [];
		groups.forEach((o) => {
			const check = _.find(groupMenu, function (g) {
				return g === o;
			});
			if (check) {
				groupMenuOrder.push(check);
			}
		});
		const res = [];
		groupMenuOrder.forEach((g) => {
			const tmp = _.filter(menuList, function (o) {
				return o.group === g;
			});
			res.push({
				group: g,
				list: tmp,
			});
		});
		return res;
	}, [menuList]);

	useEffect(() => window.scrollTo(0, 0), []);

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'Insurance Market Data',
								path: '/insurance-market-data',
							},
						]}
					/>
					<Center mt="4">
						<Box w="100%" mt={2}>
							{menuData?.map((menu, i) => {
								return (
									<Flex w="100%" key={`mm-${i}`} direction="column">
										<Text fontWeight="bold" color="rgba(52, 73, 94,.7)">
											{t(menu?.group)}
										</Text>
										<SimpleGrid mt="2" w="100%" mb="24px" columns={[1, null, 3]} spacing={['1.5rem', null, '1.5rem']}>
											{menu?.list?.map((m, index) => {
												const isDisabled = m.isDisabled;
												return (
													<AspectRatio
														key={'menu-' + index}
														maxW="100%"
														ratio={10 / 2.2}
														cursor={isDisabled ? 'not-allowed' : 'pointer'}
														opacity={isDisabled ? 0.4 : 1}
													>
														<Card>
															<Flex
																w="100%"
																h="100%"
																p={4}
																onMouseDown={() => {
																	if (!isDisabled) {
																		history.push(m.path);
																	}
																}}
																borderLeft="2px solid rgba(0,0,0,0)"
																_hover={
																	isDisabled
																		? {}
																		: {
																				transition: 'all 0.07s ease-in',
																				borderLeft: '2px solid rgba(52, 152, 219,1.0)',
																				borderRadius: c.borderRadius,
																			}
																}
																alignItems="center"
															>
																<FontAwesomeIcon icon={m.icon} style={{ fontSize: '1rem' }} />
																<Flex flex="1" ml="3">
																	<Tooltip label={t(m?.name)}>
																		<Text fontSize="1rem" fontWeight="600" noOfLines={2}>
																			{t(m?.name)}
																		</Text>
																	</Tooltip>
																</Flex>
															</Flex>
														</Card>
													</AspectRatio>
												);
											})}
										</SimpleGrid>
									</Flex>
								);
							})}
						</Box>
					</Center>
				</Container>
			</>
		</PrintLayout>
	);
}

export default InsuranceMarketDataMenu;
